import React, {Component} from 'react';
import LogoPic from "../../assets/images/logo.png";
import API from '../../services/API';
import Toast from '../Common/Toast';
import { toast } from 'react-toastify';


class Login extends Component {
    state = {
        mobile : window.localStorage.getItem("mainMobile") ? window.localStorage.getItem("mainMobile") : "",
        password : "",
        buttonStatus:  window.localStorage.getItem("mainMobile") ? "" : "disabled",
        buttonText : "ورود به سامانه",
        loading: "d-none",
        message: ""
    }
    onInputChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        if (name === 'mobile') {

            if (value.length >= 12) {
                return false;
            }
            if (value[0] === '0' && value[1] === '9' && value.length === 11) {
                this.setState({buttonStatus: ""})
            } else {
                this.setState({buttonStatus: "disabled"})
            }
        }

        this.setState({[name] :value });
    }
    onButtonClick =  () => {
        const buttonText  = "";
        const  loading = "d-inline-block";
        const buttonStatus = "disabled";
        this.setState({buttonText,loading,buttonStatus });
        const mobile = this.state.mobile;
        const password = this.state.password;
        if(password.length < 4) {
            toast.error('کلمه عبور را کامل وارد کنید');
            const buttonText  = "ورود به سامانه";
            const  loading = "d-none";
            const buttonStatus = "";
            this.setState({buttonText,loading,buttonStatus });
            return false;
        }
        API.getCarData(mobile,password)
            .then((response) => {
                const cars = response.car_act[0];

                if(cars !== undefined) {
                    toast.success('با موفقیت وارد شدید. هم اکنون به صفحه اصلی اپلیکیشن هدایت می شوید');
                    window.localStorage.setItem("mobile", this.state.mobile);
                    window.localStorage.setItem("password", this.state.password);
                    window.localStorage.setItem("connection_type", 'internet');
                    window.localStorage.removeItem("mainMobile");
                    setTimeout (() => {
                        window.location.replace("/home");
                    },1500)
                }
                else {
                    toast.error('خودرویی با شماره موبایل و گذر واژه ای که وارد کردید پیدا نشد');
                    const buttonText  = "ورود به سامانه";
                    const  loading = "d-none";
                    const buttonStatus = "";
                    this.setState({buttonText,loading,buttonStatus });
                }
/*                if(response.success) {
                    toast.success(response.user_message);
                    window.localStorage.setItem("mobile", this.state.mobile);
                    window.localStorage.setItem("new_user", response.results.new_user);
                    setTimeout (() => {
                        this.props.history.push("/verify");
                    },1500)
                }
                else {
                    toast.error(response.user_message);
                    const buttonText  = "دریافت کد تایید";
                    const  loading = "d-none";
                    const buttonStatus = "";
                    this.setState({buttonText,loading,buttonStatus });
                }*/

            })
            .catch((error) => {


            });
    }
    render() {
        return (
            <React.Fragment>
                <section className="container   max-w-lg login-window">
                    <div className="row text-center">
                        <Toast  />
                        <div className="col-12 pt-2 mb-3">
                            <img src={LogoPic} alt="سامانه پروماتیکس" className="rounded mx-auto d-block mt-5 w-25  " />
                        </div>
                        <div className="col-12 mt-4 text-right text-primary-color fw-bold  ">
                            ورود به سامانه
                        </div>
                        <div className="col-12 my-2 text-right small text-color ">
                            لطفا شماره موبایل و کلمه عبور خود را وارد کنید
                        </div>
                        <div className="col-12 mt-3 ">
                            <div className=" mb-3">
                                <input type="tel"
                                       className="form-control text-center text-big-2 "
                                       id="mobile"
                                       name="mobile"
                                       placeholder="شماره  موبایل"
                                       value={this.state.mobile}
                                       onChange={this.onInputChange}
                                />
                                    {/*<label htmlFor="mobile" className="right-0">شماره  موبایل</label>*/}
                            </div>
                        </div>
                        <div className="col-12 mt-2 ">
                            <div className=" mb-3">
                                <input type="password"
                                       className="form-control text-center text-big-2 "
                                       id="password" name="password"
                                       placeholder="  کلمه عبور"
                                       value={this.state.password}
                                       onChange={this.onInputChange}
                                />
                                   {/* <label htmlFor="password" className="right-0">کلمه عبور  </label>*/}
                            </div>
                        </div>
                        <div className="col-12 text-center fixed-bottom-absolute mb-5 pb-3 max-w-lg not-show-mobile">
                            <button onClick={this.onButtonClick} disabled={this.state.buttonStatus} type="submit"
                                    className="btn btn-primary  w-100 py-2 ">
                                {this.state.buttonText}
                                <span  className={"spinner-grow spinner-grow-sm " + this.state.loading} role="status"
                                       aria-hidden="true">

                            </span>
                            </button>
                        </div>

                    </div>
                    <div className="row rtl text-secondary text-small-2 mx-2 mt-5 text-justify">
                        <div className="col-12 mb-2 pb-2 border-bottom text-center">
                            در صورتی که پسورد خود را فراموش کرده اید:
                        </div>
                        <ul>
                            <li className="col-12 mt-2">
                                از شماره موبایل خود
                                &nbsp;
                                { this.state.mobile}
                                 &nbsp;
                                عبارت
                                *pass
                                را به سیمکارت ردیاب پیامک کنید تا پسورد برای شما پیامک شود
                            </li>
                            <li className="col-12 mt-2">

                                کلید سخت افزاری ریست دستگاه را 10 ثانیه فشار دهید (دستگاه ریست می شود)
                                &nbsp;
                                <span className='text-primary'
                                onClick={
                                    () => this.props.history.push('/register')
                                }
                                >
                                                                    و سپس برای ثبت نام مجدد اینجا را کلیک کنید

                                </span>
                            </li>
                            <li className="col-12 mt-2">
                              درب خودرو را باز نگاه دارید و سوییچ را ۸ بار سریع خاموش و روشن کنید
                                (دستگاه ریست می شود)
                                &nbsp;
                                <span className='text-primary'
                                      onClick={
                                          () => this.props.history.push('/register')
                                      }
                                >
                                                                    و سپس برای ثبت نام مجدد اینجا را کلیک کنید

                                </span>
                            </li>
                        </ul>

                    </div>
                </section>

            </React.Fragment>
        );
    }
    componentDidMount() {
        const mobile = window.localStorage.getItem("mobile");
        const password = window.localStorage.getItem("password");

        if(mobile && password ) {
            window.location.replace('/home')
        }
    }
}

export default Login;